/**
 * Contratos e comunicação com empregador (CLT).
 *
 * Fora de `suppliers/` de propósito: a listagem parte da conciliação e cruza
 * mais de uma bancarizadora, então não é de um par produto × banco.
 */

import { httpV1 as http } from '@/services/api';

export async function getContracts(params) {
  const { data } = await http.get('/private-payroll/contracts', { params });
  return data;
}

export async function getCltContracts(params) {
  const { data } = await http.get('/private-payroll/clt-contracts', { params });
  return data;
}

export async function getCltContractByProposalId(proposal_id) {
  const { data } = await http.get(`/private-payroll/clt-contracts/${proposal_id}`);
  return data;
}

export async function getContractByProposalId(proposal_id) {
  const { data } = await http.get(`/private-payroll/contracts/${proposal_id}`);
  return data;
}

export async function getCompaniesContracts(params) {
  return http.get('/private-payroll/contracts', { params });
}

export async function getCompaniesWithWrittenContracts(params) {
  return http.get('/private-payroll/companies-with-written-contracts', { params });
}

export async function getCommunicationsByProposalId(params) {
  const { data } = await http.get('/private-payroll/employer-communications', { params });
  return data;
}

export async function getCommunicationById(id) {
  const { data } = await http.get(`/private-payroll/employer-communications/${id}`);
  return data;
}

export async function getCommunicationHistory({ id, ...params }) {
  const { data } = await http.get(`/private-payroll/employer-communications/${id}/history`, { params });
  return data;
}

export async function registerActivitie({ communication_id, ...data }) {
  return http.post(`/private-payroll/employer-communications/${communication_id}/history`, data);
}

export async function saveNote({ id, ...data }) {
  return http.put(`/private-payroll/employer-communications/history/${id}/notes`, data);
}

export async function getEmailTemplates(params) {
  const { data } = await http.get('/private-payroll/email-templates', { params });
  return data;
}

export async function createCommunication(data) {
  return http.post('/private-payroll/employer-communications/manual', data);
}

export async function changeCommunicationStatus({ id, ...data }) {
  return http.put(`/private-payroll/employer-communications/${id}/status`, data);
}

export async function getChannels(params) {
  const { data } = await http.get('/private-payroll/channels', { params });
  return data;
}
